import React from 'react';

// NOTE: Original svgs are in the assets folder, I converted them to react components
// with `npx @svgr/cli -d ./assets ./ --typescript` and put them here

export const InvisibleIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
		<path
			className="invisible_svg__st0"
			d="M10.6 8c0 .4-.1.8-.3 1.1L7.8 6.7c.1-.1.1-.3.1-.5 0-.3-.1-.5-.2-.7H8c1.4-.1 2.6 1.1 2.6 2.5zM12.6 12.3l-1.7-1.7-1-1-2.5-2.5-1-1-.6-.5-.4-.5-3.6-3.6-.7.7L2.9 4C1.5 5 .5 6.4.1 8c.8 3.2 4 5.6 7.9 5.6 1.3 0 2.6-.3 3.7-.8l1.7 1.7.7-.7-1.5-1.5zM8 11.9c-2.2 0-3.9-1.8-3.9-3.9 0-.8.2-1.5.6-2.1l1 1c-.1.3-.2.7-.2 1.1 0 1.4 1.1 2.5 2.5 2.5.4 0 .8-.1 1.1-.3l1 1c-.6.4-1.3.7-2.1.7z"
		/>
		<path
			className="invisible_svg__st0"
			d="M15.9 7.9c-.4 1.6-1.4 3-2.8 4L11.2 10c.4-.6.6-1.4.6-2.2.1-2-1.6-3.8-3.8-3.8-.8 0-1.5.3-2.2.7L4.3 3.1c1.1-.5 2.4-.8 3.7-.8 3.8 0 7.1 2.4 7.9 5.6z"
		/>
	</svg>
);

export const VisibleIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
		<path
			className="visible_svg__st0"
			d="M10.5 7.9c0 1.4-1.1 2.5-2.5 2.5S5.5 9.3 5.5 7.9c0-.5.1-.9.3-1.3.2.3.6.6 1 .6.6 0 1.1-.5 1.1-1.1 0-.3-.1-.5-.2-.7H8c1.4-.1 2.5 1.1 2.5 2.5z"
		/>
		<path
			className="visible_svg__st0"
			d="M8 2.2C4.2 2.2.9 4.6.1 7.8c.8 3.2 4 5.6 7.9 5.6 3.8 0 7.1-2.4 7.9-5.6-.8-3.2-4.1-5.6-7.9-5.6zm0 9.6c-2.2 0-3.9-1.8-3.9-3.9s1.7-4 3.9-4c2.1 0 3.9 1.7 3.9 3.9s-1.8 4-3.9 4z"
		/>
		<path
			className="visible_svg__st0"
			d="M10.5 7.9c0 1.4-1.1 2.5-2.5 2.5S5.5 9.3 5.5 7.9c0-.5.1-.9.3-1.3.2.3.6.6 1 .6.6 0 1.1-.5 1.1-1.1 0-.3-.1-.5-.2-.7H8c1.4-.1 2.5 1.1 2.5 2.5z"
		/>
		<path
			className="visible_svg__st0"
			d="M10.5 7.9c0 1.4-1.1 2.5-2.5 2.5S5.5 9.3 5.5 7.9c0-.5.1-.9.3-1.3.2.3.6.6 1 .6.6 0 1.1-.5 1.1-1.1 0-.3-.1-.5-.2-.7H8c1.4-.1 2.5 1.1 2.5 2.5z"
		/>
	</svg>
);
